module.exports = __webpack_public_path__ + "WorkSans-Black.b63c56a7f6cb2581264e.ttf";


//////////////////
// WEBPACK FOOTER
// D:/F210-INGRESO/cambio_enlace_ayuda/rec_ng_ingresorenta210/src/assets/fonts_v2/Work_Sans/WorkSans-Black.ttf
// module id = ../../../../../src/assets/fonts_v2/Work_Sans/WorkSans-Black.ttf
// module chunks = styles